export const views = {
  noPregnancies: "noPregnancies",
  general: "general",
  anteNatal: "anteNatal",
  postNatal: "postNatal",
  messages: "messages",
};

export const emptyView = { name: views.noPregnancies, pregnancyId: null };

/*
 * The selected pregnancy can disappear from under an open page — deleted, merged away or otherwise
 * removed — and the list query then comes back without it (KIN-2047). The selection lives in React
 * state only, so it has to be reconciled against every list we receive, and reconciled *during
 * render*: an effect runs after the render that already handed `undefined` to the view, which is
 * precisely the frame that crashed the page.
 */
export const resolvePregnancyView = (view, pregnancies) => {
  // No list yet — first load, a failed fetch or a disabled query. A missing list is not a missing
  // pregnancy, and resetting on it would bounce the user off their selection on every refetch.
  if (!Array.isArray(pregnancies)) {
    return view;
  }

  if (pregnancies.length === 0) {
    return view.name === views.noPregnancies ? view : emptyView;
  }

  const isSelectionStillListed = pregnancies.some(
    ({ id }) => id === view.pregnancyId
  );

  // Same list, same selection: keep the view the user is on, down to the tab and the object
  // identity, so a refetch never jumps them back to the first pregnancy or to the General tab.
  if (isSelectionStillListed) {
    return view;
  }

  return { name: views.general, pregnancyId: pregnancies.at(0).id };
};
